{
  "familyId": "SWW-TT-INV-JIJ",
  "questions": [
    {
      "id": "SWW-TT-INV-JIJ-001",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "multiple_choice",
      "question": "Morgen ... jij naar de tandarts. (gaan)",
      "context": "Mama prikt het bezoek aan op de kalender en zegt tegen Liam:",
      "options": ["ga", "gaat", "ging", "gegaan"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversieregel", "content": "Bij inversie staat 'jij' ACHTER het werkwoord. Dan valt de -t weg: ga jij, loop jij, werk jij. Vergelijk: 'jij gaat' (gewone volgorde, mét -t) versus 'ga jij?' (inversie, zonder -t).", "icon": "lightbulb" }
        }
      ],
      "conceptId": "present_tense_inversion_jij",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Stap 1: staat 'jij' achter het werkwoord? Ja → inversie. Stap 2: bij inversie met jij valt de -t weg → gebruik alleen de stam. Stam van 'gaan' = 'ga'. Antwoord: 'Morgen ga jij naar de tandarts.'",
        "solutionSteps": [
          "Stap 1 — Herken inversie: 'jij' staat ACHTER het werkwoord",
          "Stap 2 — Bij inversie met jij: gebruik alleen de stam (geen -t)",
          "Stap 3 — Stam van 'gaan' = ga",
          "Antwoord: 'Morgen ga jij naar de tandarts.'"
        ],
        "distractorExplanations": {
          "0": "Correct! Inversie met jij = stam zonder -t: ga.",
          "1": "Bij inversie valt de -t weg. 'Gaat' is de gewone jij-vorm ('Jij gaat'), maar als jij ACHTER het werkwoord staat, wordt het 'Ga jij?'. Onthoud: inversie = geen -t.",
          "2": "'Ging' is de verleden tijd van 'gaan'. Het signaalwoord 'morgen' wijst op de toekomst, dus gebruik je de tegenwoordige tijd: ga.",
          "3": "'Gegaan' is het voltooid deelwoord en hoort bij 'ben gegaan'. Hier is geen hulpwerkwoord, dus gebruik je gewoon de tegenwoordige tijd: ga."
        }
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "comprehension",
        "misconceptionTags": [
          { "id": "sww.inversie-t-niet-weg", "label": "Inversie niet herkend: -t blijft staan", "optionIndex": 1 },
          { "id": "sww.inversie-tijd-verward", "label": "Verleden tijd gebruikt bij tegenwoordige context", "optionIndex": 2 },
          { "id": "sww.inversie-vd-gebruikt", "label": "Voltooid deelwoord zonder hulpwerkwoord", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-002",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "text_highlight",
      "question": "Klik op het woord met een inversie-fout:",
      "context": "Loopt jij ook mee naar de winkel?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "segments": [
          {"id": "seg-0", "text": "Loopt", "isCorrect": true, "isTappable": true},
          {"id": "sep-0", "text": " ", "isTappable": false},
          {"id": "seg-1", "text": "jij", "isCorrect": false, "isTappable": true},
          {"id": "sep-1", "text": " ", "isTappable": false},
          {"id": "seg-2", "text": "ook", "isCorrect": false, "isTappable": true},
          {"id": "sep-2", "text": " ", "isTappable": false},
          {"id": "seg-3", "text": "mee", "isCorrect": false, "isTappable": true},
          {"id": "sep-3", "text": " ", "isTappable": false},
          {"id": "seg-4", "text": "naar", "isCorrect": false, "isTappable": true},
          {"id": "sep-4", "text": " ", "isTappable": false},
          {"id": "seg-5", "text": "de", "isCorrect": false, "isTappable": true},
          {"id": "sep-5", "text": " ", "isTappable": false},
          {"id": "seg-6", "text": "winkel?", "isCorrect": false, "isTappable": true}
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversieregel", "content": "Bij inversie staat 'jij' ACHTER het werkwoord. Dan valt de -t weg: Loop jij? (niet Loopt jij).", "icon": "lightbulb" }
        }
      ],
      "conceptId": "inversion_error_text_highlight",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Stap 1: herken inversie — 'jij' staat achter het werkwoord 'Loopt'. Stap 2: regel toepassen — bij inversie met jij valt de -t weg. Stap 3: Loopt → Loop. De fout zit dus in 'Loopt'.",
        "solutionSteps": [
          "Stap 1 — Lees de zin: 'Loopt jij ook mee naar de winkel?'",
          "Stap 2 — Herken inversie: 'jij' staat achter het werkwoord",
          "Stap 3 — Inversieregel: -t valt weg → Loopt → Loop",
          "De fout zit in 'Loopt' — moet 'Loop' zijn"
        ],
        "distractorExplanations": {
          "0": "Correct! 'Loopt' moet 'Loop' zijn. Bij inversie met jij valt de -t weg: Loop jij?"
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis"
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-003",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "multiple_choice",
      "question": "Welke zin is correct geschreven?",
      "context": "Papa belt je op vrijdag om half acht 's ochtends. Welke zin schrijft hij in zijn appje?",
      "options": [
        "Werk jij vandaag op kantoor?",
        "Werkt jij vandaag op kantoor?",
        "Werken jij vandaag op kantoor?",
        "Gewerkt jij vandaag op kantoor?"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversieregel", "content": "Bij inversie staat 'jij' ACHTER het werkwoord. Dan valt de -t weg: werk jij (niet werkt jij). Vergelijk: 'jij werkt' (mét -t) → 'werk jij?' (zonder -t).", "icon": "lightbulb" }
        }
      ],
      "conceptId": "inversion_correct_sentence",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Stap 1: in alle vier de zinnen staat 'jij' achter het werkwoord → inversie. Stap 2: bij inversie valt de -t weg. Stam van 'werken' = 'werk'. Stap 3: 'Werk jij?' is correct.",
        "solutionSteps": [
          "Stap 1 — Herken inversie: 'jij' staat achter het werkwoord",
          "Stap 2 — Stam van 'werken' = werk",
          "Stap 3 — Bij inversie: stam zonder -t → werk jij",
          "'Werk jij vandaag op kantoor?' is correct ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Werk jij' is correct — bij inversie valt de -t weg.",
          "1": "Je dacht waarschijnlijk dat jij altijd -t krijgt. Maar bij inversie (jij achter het werkwoord) valt de -t weg: werk jij, niet werkt jij. Onthoud: inversie = geen -t.",
          "2": "'Werken' is de infinitief of meervoudsvorm (wij werken). Bij jij gebruik je de stam: werk. Onthoud: jij-vorm = stam (+ t bij gewone volgorde, zonder t bij inversie).",
          "3": "'Gewerkt' is het voltooid deelwoord. Dat hoort bij 'heb gewerkt'. Hier heb je de tegenwoordige tijd nodig: werk jij."
        }
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "comprehension",
        "misconceptionTags": [
          { "id": "sww.inversie-t-niet-weg", "label": "Inversie niet toegepast: -t blijft staan", "optionIndex": 1 },
          { "id": "sww.inversie-infinitief", "label": "Infinitief in plaats van stam gebruikt", "optionIndex": 2 },
          { "id": "sww.inversie-vd-gebruikt", "label": "Voltooid deelwoord gebruikt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-004",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "fill_in",
      "question": "Vul de juiste vorm in: '... jij altijd zo vroeg op?' (staan)",
      "context": "Oma is op bezoek en ziet je om zes uur al beneden zitten.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["Sta", "sta"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversieregel", "content": "Bij inversie staat 'jij' ACHTER het werkwoord. Dan gebruik je alleen de stam (geen -t). De stam van 'staan' is 'sta'. Dus: Sta jij? (niet Staat jij).", "icon": "lightbulb" }
        }
      ],
      "conceptId": "inversion_fill_in",
      "variantIndex": 4,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Stap 1: 'jij' staat achter het werkwoord → inversie. Stap 2: stam van 'staan' = 'sta'. Stap 3: bij inversie geen -t → Sta jij. Antwoord: 'Sta jij altijd zo vroeg op?'",
        "solutionSteps": [
          "Stap 1 — Herken inversie: 'jij' staat achter het werkwoord",
          "Stap 2 — Stam van 'staan' = sta",
          "Stap 3 — Bij inversie: geen -t → sta jij",
          "Antwoord: 'Sta jij altijd zo vroeg op?'"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application"
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-005",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "multiple_choice",
      "question": "In welke zin is de inversieregel GOED toegepast?",
      "context": "In de klas gaan jullie samen op zoek naar de juiste werkwoordsvorm voor een quizvraag.",
      "options": [
        "Fiets jij elke dag naar school?",
        "Fietst jij elke dag naar school?",
        "Jij fiets elke dag naar school.",
        "Fietsen jij elke dag naar school?"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversie vs. gewone volgorde", "content": "Bij inversie staat 'jij' ACHTER het werkwoord → geen -t. Bij gewone volgorde staat 'jij' VOOR het werkwoord → wél -t. Vergelijk: 'Jij fietst' → 'Fiets jij?'", "icon": "lightbulb" }
        }
      ],
      "conceptId": "inversion_recognition",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Stappenplan: per zin checken — staat 'jij' voor of achter het werkwoord? En past de -t daarbij? 'Fiets jij' is correct: inversie met stam zonder -t. Stam van 'fietsen' = 'fiets'.",
        "solutionSteps": [
          "Stap 1 — Check elke zin op inversie (jij achter werkwoord)",
          "'Fiets jij' → inversie, stam zonder -t → correct ✓",
          "'Fietst jij' → inversie maar mét -t → fout",
          "'Jij fiets' → gewone volgorde maar zonder -t → fout",
          "'Fietsen jij' → infinitief, niet de stam → fout"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Fiets jij' is correct — inversie met stam zonder -t.",
          "1": "Bij inversie valt de -t weg! 'Fietst jij' is fout — het moet 'Fiets jij' zijn. Onthoud: jij achter werkwoord = geen -t.",
          "2": "'Jij fiets' is fout. Bij gewone volgorde (jij VOOR het werkwoord) krijg je wél -t: 'Jij fietst'. Onthoud: gewone volgorde = stam + t.",
          "3": "'Fietsen' is de infinitief (hele werkwoord). Bij jij gebruik je de stam: fiets. Onthoud: jij-vorm = stam (+ t bij gewone volgorde, zonder t bij inversie)."
        }
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.inversie-t-niet-weg", "label": "Inversie niet toegepast (-t blijft)", "optionIndex": 1 },
          { "id": "sww.inversie-t-vergeten", "label": "Gewone volgorde maar -t vergeten", "optionIndex": 2 },
          { "id": "sww.inversie-infinitief", "label": "Infinitief gebruikt in plaats van stam", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-006",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "error_spotting",
      "question": "Zoek de fouten in deze tekst. Tik op een fout woord.",
      "context": "Een klasgenoot heeft een tekstje geschreven over zijn snelle vriendinnetje. Help hem de fouten te vinden.",
      "options": [],
      "correctAnswer": null,
      "data": {
        "text": "Jij loopt snel naar school. Loopt jij altijd zo hard? Waarom wacht jij niet even? Wacht jij op mij?",
        "errors": [
          { "word": "Loopt", "position": 5, "correction": "Loop", "rule": "Inversie bij jij: stam zonder -t (Loop jij)" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inversie: jij achter het werkwoord",
            "content": "Als 'jij' of 'je' ACHTER het werkwoord staat, valt de -t weg. Je gebruikt dan alleen de stam. Dus: Jij loopt, maar: Loop jij? Jij wacht, maar: Wacht jij?",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inversie_error_spotting_06",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Per zin checken: staat 'jij' voor of achter het werkwoord? In 'Loopt jij altijd zo hard?' staat jij achter het werkwoord → inversie → -t valt weg → 'Loop jij'. Bij 'Jij loopt' staat jij ervóór, dus wel een -t. Bij 'Wacht jij' eindigt de stam al op een -t, dus dat blijft gewoon 'wacht'.",
        "solutionSteps": [
          "Stap 1 — Check 'Jij loopt': gewone volgorde → stam + t (loopt) = goed",
          "Stap 2 — Check 'Loopt jij': inversie → stam zonder t (loop) = fout",
          "Stap 3 — Check 'wacht jij': inversie → stam zonder t (wacht) = goed"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis"
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-007",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "multiple_choice",
      "question": "Welke vorm hoort hier?\n'... jij ook mee?' (komen)",
      "context": "Lotte rent het schoolplein op en roept naar haar vriendin.",
      "options": ["Kom", "Komt", "Komen", "Gekomen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": { "title": "Inversie met jij", "content": "Bij inversie staat 'jij' ACHTER het werkwoord. Dan valt de -t weg. Stam van 'komen' = kom → kom jij?", "icon": "lightbulb" }
        }
      ],
      "conceptId": "inversie_instap_komen",
      "variantIndex": 7,
      "citoDifficulty": 0.15,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Stap 1: 'jij' staat achter het werkwoord → inversie. Stap 2: bij inversie geen -t → stam alleen. Stam van 'komen' = 'kom'. Antwoord: 'Kom jij ook mee?'",
        "solutionSteps": [
          "Stap 1 — Inversie: 'jij' staat achter het werkwoord",
          "Stap 2 — Stam van 'komen' = kom",
          "Stap 3 — Bij inversie geen -t → kom jij"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Kom jij' is correct — inversie zonder -t.",
          "1": "Bij inversie valt de -t weg. 'Komt jij' is fout — moet 'Kom jij' zijn.",
          "2": "'Komen' is de infinitief. Bij jij gebruik je de stam: kom.",
          "3": "'Gekomen' is het voltooid deelwoord. Dat hoort bij 'ben gekomen'."
        }
      },
      "pedagogy": {
        "dok": 1,
        "cognitiveLevel": "recall",
        "misconceptionTags": [
          { "id": "sww.inversie-t-niet-weg", "label": "Inversie niet toegepast: -t blijft staan", "optionIndex": 1 },
          { "id": "sww.inversie-infinitief", "label": "Infinitief gebruikt in plaats van stam", "optionIndex": 2 },
          { "id": "sww.inversie-vd-gebruikt", "label": "Voltooid deelwoord gebruikt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-008",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "categorize",
      "question": "Sorteer de zinnen op gewone volgorde of inversie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Gewone volgorde (jij + werkwoord-t)", "Inversie (werkwoord + jij, géén -t)"],
        "items": [
          { "text": "Jij loopt snel.", "correctCategory": 0 },
          { "text": "Loop jij ook mee?", "correctCategory": 1 },
          { "text": "Jij werkt hard.", "correctCategory": 0 },
          { "text": "Werk jij ook morgen?", "correctCategory": 1 },
          { "text": "Fiets jij iedere dag?", "correctCategory": 1 },
          { "text": "Jij fietst graag in het bos.", "correctCategory": 0 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gewone volgorde vs. inversie",
            "content": "Gewone volgorde: jij staat VOOR het werkwoord → stam + t. Inversie: werkwoord staat VOOR jij → geen -t.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inversie_categorize",
      "variantIndex": 8,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Per zin: kijk waar 'jij' staat ten opzichte van het werkwoord. Voor → gewone volgorde (stam + t). Achter → inversie (geen -t). De zinnen met '?' zijn vaak inversie, maar niet altijd — kijk goed naar de volgorde.",
        "solutionSteps": [
          "Stap 1 — Lokaliseer 'jij' in de zin",
          "Stap 2 — Staat jij vóór het werkwoord? → gewone volgorde (mét -t)",
          "Stap 3 — Staat jij achter het werkwoord? → inversie (zonder -t)"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis"
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-009",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "true_false_series",
      "question": "Klopt elke zin? Lees goed of de inversieregel correct is toegepast.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Jij rent snel naar huis.", "isTrue": true, "explanation": "Gewone volgorde: jij staat voor het werkwoord → stam + t (rent). Correct." },
          { "text": "Rent jij ook hard?", "isTrue": false, "explanation": "Inversie: jij staat achter het werkwoord → -t valt weg. Stam van 'rennen' = ren. Moet zijn: 'Ren jij ook hard?'." },
          { "text": "Werkt jij vandaag?", "isTrue": false, "explanation": "Inversie: jij staat achter het werkwoord → geen -t. Moet zijn: 'Werk jij vandaag?'." },
          { "text": "Loop jij elke dag naar school?", "isTrue": true, "explanation": "Inversie: jij staat achter het werkwoord → geen -t. Stam van 'lopen' = loop. Correct." },
          { "text": "Jij wachten op de bus.", "isTrue": false, "explanation": "Gewone volgorde maar infinitief gebruikt. Moet zijn: 'Jij wacht op de bus.' (stam + t)." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Twee regels combineren",
            "content": "Gewone volgorde (jij vóór werkwoord): stam + t. Inversie (jij na werkwoord): alleen stam, geen -t. Check eerst de volgorde, dan de uitgang.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inversie_tf_series",
      "variantIndex": 9,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Per zin: stap 1 lokaliseer jij ten opzichte van het werkwoord, stap 2 controleer de uitgang. 'Werkt jij' moet 'Werk jij' (inversie zonder -t). 'Jij wachten' moet 'Jij wacht' (gewone volgorde, stam + t).",
        "solutionSteps": [
          "Stap 1 — Bepaal volgorde: jij voor of achter werkwoord?",
          "Stap 2 — Controleer uitgang: gewone volgorde = stam + t, inversie = stam zonder -t",
          "Stap 3 — Vergelijk met wat in de zin staat"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis"
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-010",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "error_spotting",
      "question": "Zoek de inversie-fout. Let op het verschil tussen 'jij' en 'hij': bij 'jij' valt de -t weg, bij 'hij' niet.",
      "context": "Lisa schrijft een appje aan haar broer over een spannend boek. Help haar de fout te vinden.",
      "options": [],
      "correctAnswer": null,
      "data": {
        "text": "Jij vindt dit boek leuk. Vind jij het spannend? Hij vindt het ook mooi. Vind hij het ook spannend?",
        "errors": [
          { "word": "Vind", "position": 17, "correction": "Vindt", "rule": "Bij inversie met 'hij' blijft de -t staan: Vindt hij (niet: Vind hij). De -t vervalt alleen bij 'jij'." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inversie: jij vs. hij",
            "content": "Let op het verschil! Bij 'jij' valt de -t weg: vind jij (zonder -t). Bij 'hij' blijft de -t staan: vindt hij (met -t). De inversie-regel met -t weg geldt ALLEEN bij 'jij', niet bij hij/zij/het.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inversie_jij_vs_hij",
      "variantIndex": 10,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De -t-regel bij inversie geldt ALLEEN bij 'jij'. Bij 'hij' (of 'zij'/'het') blijft de -t altijd staan. Per zin: 'Jij vindt' = gewone volgorde met -t ✓. 'Vind jij?' = inversie met jij → -t valt weg ✓. 'Hij vindt' = gewone volgorde met -t ✓. 'Vind hij?' = inversie met hij → -t MOET blijven → fout, moet 'Vindt hij?' zijn.",
        "solutionSteps": [
          "Stap 1 — Check elke zin: wie is het onderwerp en waar staat het?",
          "Stap 2 — Bij 'jij' achter werkwoord: -t valt weg (Vind jij ✓)",
          "Stap 3 — Bij 'hij' achter werkwoord: -t BLIJFT staan (Vindt hij)",
          "De fout: 'Vind hij' moet 'Vindt hij' zijn"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.inversie-overgeneraliseren-jij", "label": "Inversie-regel onterecht toegepast bij hij/zij" }
        ]
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-011",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "fill_in",
      "question": "Vul in: Wanneer ... (komen) jij naar het feest?",
      "context": "Lisa appt haar beste vriendin een uur voor het feestje.",
      "correctAnswer": "kom",
      "data": {
        "acceptedAnswers": ["kom"],
        "placeholder": "werkwoord invullen...",
        "inputType": "text"
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Inversie met jij", "content": "Bij inversie (jij achter het werkwoord) valt de -t weg. Komen → stam = kom. Inversie: kom jij (niet komt jij).", "icon": "lightbulb" } }
      ],
      "conceptId": "inversie_fill_in_kom",
      "variantIndex": 11,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Stap 1: 'jij' staat achter het werkwoord → inversie. Stap 2: stam van 'komen' = 'kom'. Stap 3: bij inversie geen -t → 'kom jij'. Antwoord: 'Wanneer kom jij naar het feest?'",
        "solutionSteps": [
          "Stap 1 — Stam van 'komen' = kom",
          "Stap 2 — 'Jij' staat achter het werkwoord → inversie",
          "Stap 3 — Inversie met jij → geen -t: kom jij"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "cognitiveLevel": "application",
        "misconceptionTags": [
          { "id": "sww.inversie-t-niet-weg", "label": "Bij inversie de -t niet weggehaald" }
        ]
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-012",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "error_spotting",
      "question": "Vind de inversiefouten in deze zinnen.",
      "context": "Tijdens een tekstcontrole vind je twee inversiefouten in de tekst van een klasgenoot.",
      "correctAnswer": null,
      "data": {
        "text": "Gaat jij mee naar het zwembad? Jij loopt altijd zo snel. Fietst jij elke dag naar school?",
        "errors": [
          { "word": "Gaat", "position": 0, "correction": "Ga", "explanation": "Bij inversie (jij achter het werkwoord) valt de -t weg. Gaan → stam = ga. Inversie: ga jij (niet gaat jij)." },
          { "word": "Fietst", "position": 11, "correction": "Fiets", "explanation": "Bij inversie valt de -t weg. Fietsen → stam = fiets. Inversie: fiets jij (niet fietst jij)." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Inversie met jij", "content": "Bij inversie (jij achter het werkwoord) valt de -t weg. Ga jij, loop jij, fiets jij. Maar: jij gaat, jij loopt, jij fietst (geen inversie = wel -t).", "icon": "lightbulb" } }
      ],
      "conceptId": "inversie_error_spotting_12",
      "variantIndex": 12,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Per zin: check de volgorde van jij en werkwoord, controleer de uitgang. Twee fouten: 1) 'Gaat jij' → 'Ga jij' (inversie: -t valt weg). 2) 'Fietst jij' → 'Fiets jij' (inversie: -t valt weg). 'Jij loopt' is correct: geen inversie, dus wel -t.",
        "solutionSteps": [
          "Stap 1 — Check: staat 'jij' achter het werkwoord? Dan inversie → geen -t",
          "Stap 2 — 'Gaat jij' → inversie → ga jij",
          "Stap 3 — 'Fietst jij' → inversie → fiets jij",
          "'Jij loopt' → geen inversie → wel -t ✓"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "cognitiveLevel": "analysis",
        "misconceptionTags": [
          { "id": "sww.inversie-t-niet-weg", "label": "Bij inversie de -t niet weggehaald" },
          { "id": "sww.inversie-t-blijft-staan", "label": "-t blijft onterecht staan bij inversie met jij" }
        ]
      }
    },
    {
      "id": "SWW-TT-INV-JIJ-013",
      "familyId": "SWW-TT-INV-JIJ",
      "module": "SpellingWW",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_basis",
      "questionType": "verb_conjugation_flow",
      "question": "Vervoeg 'lopen' bij inversie met 'jij'.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "verb": "lopen",
        "targetForm": "tegenwoordige tijd (inversie met jij)",
        "context": "Hoe vaak ... jij naar school? (lopen)",
        "finalAnswer": "loop",
        "steps": [
          {
            "id": "step1",
            "prompt": "Staat 'jij' achter het werkwoord (inversie)?",
            "type": "choice",
            "options": [
              { "label": "Ja, inversie → -t valt weg", "value": "inversie", "isCorrect": true },
              { "label": "Nee, geen inversie → wel -t", "value": "geen", "isCorrect": false, "feedback": "'Hoe vaak loop/loopt jij' — 'jij' staat ACHTER het werkwoord, dus inversie. De -t valt weg." }
            ]
          },
          {
            "id": "step2",
            "prompt": "Vul de juiste vorm in: Hoe vaak ... jij naar school?",
            "type": "input",
            "acceptedAnswers": ["loop"]
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Inversie met jij",
            "content": "Bij inversie (jij ACHTER het werkwoord) valt de -t weg. Stam van 'lopen' = 'loop'. Inversie → loop jij (niet loopt jij). Maar: 'jij loopt' (geen inversie = wel -t).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inversie_jij_flow",
      "variantIndex": 13,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Stap 1: 'jij' staat achter het werkwoord → inversie. Stap 2: stam van 'lopen' = 'loop' → loop jij (geen -t). Vergelijk: 'jij loopt naar school' (geen inversie) = wel -t.",
        "solutionSteps": [
          "Check: staat 'jij' achter het werkwoord? Ja → inversie",
          "Stam van lopen = loop",
          "Inversie → -t valt weg → loop jij"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "sww.inversie-t-niet-weg", "label": "Bij inversie de -t niet weggehaald" }
        ]
      }
    }
  ]
}